import { Store } from 'store/index';
import { ProductType } from '../types';
import getDesignedProduct from './getDesignedProduct';
import getProductType from './getProductType';

const getIsGettyDesignProduct = (store: Store) => {
  const productType = getProductType(store);
  switch (productType) {
    case ProductType.predesigned:
      return getDesignedProduct(store)?.content.isGettyImagesDesign;
      break;
    case ProductType.personalized:
      return false;
      break;
    default:
      return undefined;
  }
};

export default getIsGettyDesignProduct;
